import React from "react";
import SettingsConnectors from "@/components/settings/SettingsConnectors";

/**
 * The Sources screen.
 *
 * A titled wrapper around the same component the Settings tab renders, so
 * there is one connector manager rather than two that can disagree.
 */
export default function Connectors() {
  return (
    <div className="px-4 py-5 md:px-8 md:py-6">
      <div className="mb-5">
        <div className="text-[11px] uppercase tracking-[0.18em] mb-1" style={{ color: "var(--text-muted)" }}>Connector Layer</div>
        <h1 className="font-display text-[26px]">Sources</h1>
        <p className="text-[13px] mt-1" style={{ color: "var(--text-secondary)" }}>
          Every source polls on a checkpoint, so a sync resumes rather than re-reads.
          Credentials are stored encrypted and referenced by id — never returned by the API.
        </p>
      </div>
      <SettingsConnectors />
    </div>
  );
}
